import { TPL_TO_CELL_BLOCKS_LOOKUP } from "../TPL_TO_CELL_BLOCKS_LOOKUP";

export const transformTplBlocksToCellData = ({
  allTplBlockConfigs,
  isBackendSort,
  tableConfigProp,
}) => {
  return allTplBlockConfigs
    .map((block) => {
      // Call the lookup function only once per block
      const lookupResult = TPL_TO_CELL_BLOCKS_LOOKUP({ block, tableConfigProp });
      
      // Extract comp - either the comp property or the entire result
      // cuz if the lookup responds with a single string, that is the comp name
      const comp = lookupResult?.comp || lookupResult;
      if (!comp) return undefined;

      return {
        // Column IDENTITY, not a data accessor. Derived from the field's stable
        // props.id so it survives an in-place field-type change (which mints a
        // new valuePath) — everything keyed by colId (persisted colWidths, sort
        // state, header hover/validation) stays attached to the column. Data
        // access always goes through `valuePath` below.
        colId: block.props?.id || block.valuePath,
        valuePath: lookupResult?.valuePath || block.valuePath,
        headerDisplay: extractHeaderDisplayFromBlockConfig(block),
        comp,
        props: {
          ...(block.props || {}),
          ...(lookupResult?.props || {}),
        },
        ...(isBackendSort
          ? { 
              backendSortConfig: lookupResult?.backendSortConfig || {} 
            }
          : {
              sortConfig: {
                fn: "alphabetical",
                path: block.valuePath, // this also wont work. we need valuepath to final string
              },
            }),
      };
    })
    .filter(Boolean);
};

//this is white parsing a tpl into table config
const extractHeaderDisplayFromBlockConfig = (block) =>
  block.props.label ||
  (block.valuePath === "main.title"
    ? "Title"
    : block.valuePath === "main.subtitle"
    ? "Subtitle"
    : block.valuePath);